import { render } from "./dialogChatDeleted.vue?vue&type=template&id=fcc79a7a&scoped=true"
import script from "./dialogChatDeleted.vue?vue&type=script&lang=js"
export * from "./dialogChatDeleted.vue?vue&type=script&lang=js"

import "./dialogChatDeleted.vue?vue&type=style&index=0&id=fcc79a7a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc79a7a"]])

export default __exports__